import React from 'react'
import ReactDOM from 'react-dom'

import {
    BrowserRouter,
    Switch,
    Route,
} from 'react-router-dom'

import graphql from 'common/globals/graphqlClient'
import { ClientContext } from 'graphql-hooks'
import useCurrentUser from 'common/globals/currentUser'

import Loadable from 'react-loadable'
import Loading from 'common/components/loading'

import { StylesProvider } from '@material-ui/core/styles';

import history from 'common/globals/history'

const Admin = Loadable({
    loader: () => import('admin'),
    loading: Loading,
});

const App = Loadable({
    loader: () => import('app'),
    loading: Loading,
});

const Auth = Loadable({
    loader: () => import('auth'),
    loading: Loading,
});

const Home = Loadable({
    loader: () => import('home'),
    loading: Loading,
});

const Lrec = Loadable({
    loader: () => import('lrec'),
    loading: Loading,
});



function AppRoot() {
    const user = useCurrentUser()

    return (
        <ClientContext.Provider value={graphql}>
            {!user.loading &&
                <StylesProvider injectFirst>
                    <BrowserRouter history={history}>
                        <Switch>
                            <Route path="/la-background-check" component={Lrec} />

                            <Route path="/auth" component={Auth} />

                            <Route path="/admin" component={Admin} />
                            <Route path="/admin/company" component={Admin} />

                            <Route path="/backgroundCheck" component={App} />
                            <Route path="/dashboard" component={App} />
                            <Route path="/profile" component={App} />
                            <Route path="/user/backgroundcheck" component={App} />
                            <Route path="/messages" component={App} />
                            <Route path="/settings" component={App} />
                            <Route path="/select/renew/" component={App} />
                            <Route path="/company" component={App} />

                            <Route path="/" component={Home} />
                        </Switch>
                    </BrowserRouter>
                </StylesProvider>
            }
        </ClientContext.Provider>
    )
}

ReactDOM.render(
    <AppRoot />,
    document.getElementById('root')
);
